export const LANGS = [
  { id: "en", label: "English" },
  { id: "hi", label: "हिंदी" },
  { id: "mr", label: "मराठी" },
];

export const STRINGS = {
  en: {
    yes: "Yes", no: "No",
    room: "Room", shift: "Shift", inspector_name: "Supervisor Name",
    service_type: "Cleaning Type", checkout_room: "Check-out Room", service_room: "Service Room",
    guest_name: "Guest Name", no_of_guests: "No. of Guests",
    submit_checklist: "Submit Checklist", language: "Language",
    all_yes: "All Yes", remarks: "Supervisor Remarks (optional)", optional_tag: "Optional",
    answered: "answered", pending: "pending",
    checklist_submitted: "Checklist Submitted", submitted_at: "Submitted at",
    clean_next_room: "Clean Next Room", view_report: "View Report",
    select_room: "Select a room", select_shift: "Select shift",
    cleaning_note: "A room can be cleaned & logged multiple times a day.",
    progress: "Checklist Progress",
  },
  hi: {
    yes: "हाँ", no: "नहीं",
    room: "कमरा", shift: "शिफ़्ट", inspector_name: "सुपरवाइज़र का नाम",
    service_type: "सफाई का प्रकार", checkout_room: "चेक-आउट कमरा", service_room: "सर्विस कमरा",
    guest_name: "गेस्ट का नाम", no_of_guests: "गेस्टों की संख्या",
    submit_checklist: "चेकलिस्ट सबमिट करें", language: "भाषा",
    all_yes: "सभी हाँ", remarks: "सुपरवाइज़र टिप्पणियाँ (वैकल्पिक)", optional_tag: "वैकल्पिक",
    answered: "पूर्ण", pending: "शेष",
    checklist_submitted: "चेकलिस्ट सबमिट हुई", submitted_at: "सबमिट समय",
    clean_next_room: "अगला कमरा", view_report: "रिपोर्ट देखें",
    select_room: "कमरा चुनें", select_shift: "शिफ़्ट चुनें",
    cleaning_note: "एक कमरे को दिन में कई बार साफ और दर्ज किया जा सकता है।",
    progress: "चेकलिस्ट प्रगति",
  },
  mr: {
    yes: "होय", no: "नाही",
    room: "खोली", shift: "शिफ्ट", inspector_name: "सुपरव्हायझरचे नाव",
    service_type: "सफाईचा प्रकार", checkout_room: "चेक-आउट खोली", service_room: "सर्विस खोली",
    guest_name: "गेस्टचे नाव", no_of_guests: "गेस्ट संख्या",
    submit_checklist: "चेकलिस्ट सबमिट करा", language: "भाषा",
    all_yes: "सर्व होय", remarks: "सुपरव्हायझर शेरा (ऐच्छिक)", optional_tag: "ऐच्छिक",
    answered: "पूर्ण", pending: "शिल्लक",
    checklist_submitted: "चेकलिस्ट सबमिट झाली", submitted_at: "सबमिट वेळ",
    clean_next_room: "पुढील खोली", view_report: "अहवाल पहा",
    select_room: "खोली निवडा", select_shift: "शिफ्ट निवडा",
    cleaning_note: "एक खोली दिवसातून अनेकदा साफ करून नोंदवता येते.",
    progress: "चेकलिस्ट प्रगती",
  },
};

export const t = (lang, key) => STRINGS[lang]?.[key] || STRINGS.en[key] || key;

export const itemText = (item, lang) =>
  lang === "hi" ? item.text_hi || item.text_en : lang === "mr" ? item.text_mr || item.text_en : item.text_en;

export const sectionTitle = (sec, lang) =>
  lang === "hi" ? sec.title_hi || sec.title : lang === "mr" ? sec.title_mr || sec.title : sec.title;

export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
